import * as PapaParse from 'papaparse';
import { ImportRoleRecord } from '../../api/roles';
import { PERMISSION_COLUMNS } from './permissioncolumns';

export interface ParseRolesCSVResult {
  headers: string[];
  records: ImportRoleRecord[];
  totalRows: number;
}

export const parseRolesCSV = (csvText: string): ParseRolesCSVResult => {
  if (!csvText || csvText.trim().length === 0) {
    throw new Error('File is empty');
  }

  const parsed = PapaParse.parse(csvText, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (header) => header.trim().toLowerCase(),
  });

  if (parsed.errors && parsed.errors.length > 0) {
    throw new Error(`Failed to parse CSV: ${parsed.errors[0].message}`);
  }

  const headers: string[] = parsed.meta.fields || [];
  if (!parsed.data || parsed.data.length === 0) {
    throw new Error('CSV contains no data rows');
  }

  const records: ImportRoleRecord[] = (parsed.data as Record<string, string>[]).map((row, i) => {
    const permissionColumns: Record<string, string> = {};
    for (const col of PERMISSION_COLUMNS) {
      permissionColumns[col] = row[col] ? String(row[col]).trim() : '';
    }
    return {
      rowNumber: i + 2,
      sitename: row['sitename'] ? String(row['sitename']).trim() : '',
      id: row['id'] ? String(row['id']).trim() : '',
      name: row['name'] ? String(row['name']).trim() : '',
      description: row['description'] ? String(row['description']).trim() : '',
      accountid: row['accountid'] ? String(row['accountid']).trim() : '',
      permissionColumns,
    };
  });

  return { headers, records, totalRows: records.length };
};
